import determineInitiativesPlanningSummary from "./planningSummaryForInitiatives";
const calculatePlanningSummary = (initiatives) => {
  const planGroup = {
    '<not set>': [],
    'Past due': [],
    'Due soon': [],
    'Due soon In 30 days': [],
    'Not planned': [],
    'On plan': [],
    'Realized': [],
    'Cancelled': [],
  };

  const categoryMap = {
    'Past due for L5': 'Past due',
    'Past due for L4': 'Past due',
    'Past due for L3': 'Past due',
    'Past due for L2': 'Past due',
    'Due soon for L5': 'Due soon',
    'Due soon for L4': 'Due soon',
    'Due soon for L3': 'Due soon',
    'Due soon for L2': 'Due soon',
    'Due soon for L2 for 30 days': 'Due soon In 30 days',
    'Due soon for L3 for 30 days': 'Due soon In 30 days',
    'Due soon for L4 for 30 days': 'Due soon In 30 days',
    'Due soon for L5 for 30 days': 'Due soon In 30 days',
    'Not planned (L2 to L4)': 'Not planned',
    'Not planned (L5)': 'Not planned',
    'On plan': 'On plan',
    'Realized': 'Realized',
    'Cancelled': 'Cancelled',
    '<not set>': '<not set>',
  };

  const detailedPlanningGroups = determineInitiativesPlanningSummary(initiatives);

  for (const detailedCategory in detailedPlanningGroups) {
    const summaryCategory = categoryMap[detailedCategory];
    const initiativesInDetailedCategory = detailedPlanningGroups[detailedCategory];

    if (summaryCategory && initiativesInDetailedCategory.length > 0) {
      planGroup[summaryCategory].push(...initiativesInDetailedCategory);
    }
  }

  return planGroup;
};

export default calculatePlanningSummary;